import { useState } from "react";
import { FolderApi } from "../app/api/folder.api";
import { useQuery } from "@tanstack/react-query";
import { FileApi } from "../app/api/file.api";



export function CreateFolderModal({ method, repId, refetch })
{
    const folder = FolderApi();

    const fetchFolder = async () => {
      const {data} = await folder.findAll()
      return data.data;
    };
             
    const { data } = useQuery({
        queryKey: ["folders"],
        queryFn: fetchFolder,
    });

    const handleInputs = ( event ) => {
        const { name, value } =  event.target;
        if (name === "name") {
          const exists = data?.some(
            (item) =>
              item.name?.toLowerCase() === value?.toLowerCase()
          );
          setIsChecked(exists ? 1 : -1);
        }
        setInputs( { ...inputs, [name] : value   } );
    }

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(0);

    const handleForm = async (e) => {
        e.preventDefault();
        setStatus(0);
        setIsLoading(true);
        const metadata = {
          name : inputs.name, 
          repositoryId : repId
        }
        console.log(metadata)
        try {
            const {data} = await folder.insert(metadata);
            console.log(data)
            setIsLoading(false);
            if( data.success ){
              setStatus(1);
              refetch();
            }
            else{ setStatus(-1); }
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    }

    return (

        <div className="modal-container">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center vh-100 px-2">
                    <div className="col-lg-4 col-md-6 bg-white shadow border d-flex flex-column rounded-3">
                       <div className="row px-4 py-3 border-bottom" > 
                            <div className="d-flex justify-content-between align-items-center" > 
                                <span className="lead text-secondary"> Nouveau dossier </span>
                                <button className="btn" onClick={ ()=>{ method ( false ) } } >
                                   <i className="bi bi-x-circle lead text-danger"></i> 
                                </button>
                            </div>
                        </div>
                        <form onSubmit={ handleForm } className="row p-4 d-flex flex-column">
                            
                            {
                              isLoading && (
                                <div className="d-flex justify-content-center align-items-center mb-3"> 
                                   <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                </div>
                              )
                            }
                            {
                              status === -1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-danger">
                                    Erreur de traitement. Réessayez.
                                  </div>
                                </div>
                              )
                            }
                            {
                              status === 1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-success">
                                    Dossier créer avec succès.
                                  </div>
                                </div>
                              )
                            }
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                              <div className="d-flex gap-2 mb-3">
                                <input type="text" name="name" placeholder="Nom du dossier" className={`w-100 input border py-3 px-3 text-secondary rounded-2 ${ (isChecked === -1) ? "border-success" : ( (isChecked === 1) ? "border-danger" : null  ) }`} required onChange={ handleInputs } />
                              </div>
                            </div>
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                               <button type="submit" className="btn btn-green w-100" disabled={ ( isChecked === 1 || isChecked === 0 ) && true } > 
                                  Enregistrer <i className="bi bi-arrow-right"></i> 
                               </button> 
                            </div>
                        </form>
                        <div className="row justify-content-center d-flex px-4 py-3 border-top" > 
                            { 
                                isChecked === -1 ? ( 
                                    <label className="font-sm text-success text-center"> <i className="bi bi-check-circle-fill me-2"></i> nom de dossier disponible </label> 
                                    ) : ( (isChecked === 1) ? (
                                        <label className="font-sm text-danger text-center"> <i className="bi bi-x-circle-fill me-2"></i> nom de dossier indisponible </label>  
                                        ) : ( <label className="text-secondary font-sm text-center"> <i className="bi bi-exclamation-circle me-2"></i> Le nom du dossier doit etre unique </label> ) 
                                    )
                            }              
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}





export function AddFilesModal({ method, folderId, setLoadingStatus, setStatus, setIsShown, refetch })
{
    const file = FileApi("multipart/form-data");

    const [inputs, setInputs] = useState({});
    const [isChecked, setIsChecked] = useState(0);
    const [size, setSize] = useState(0);


    const handleInputs = (event) => {
        const { name, value, files } = event.target;

        if (name === "documents") {
            let fics = Array.from(files);
            setSize(fics.length);

            if (fics.length > 30) {
                setIsChecked(-1);
                setInputs({});
                return;
            }

            setIsChecked(1);
            setInputs({ ...inputs, documents: fics });
            return;
        }

        setInputs({ ...inputs, [name]: value });
    };



    const handleForm = async (e) => {

        e.preventDefault();
        method(false);
        setIsShown (true);
        setLoadingStatus(true);
        console.log(inputs

        )

        let formData = new FormData();
        for (let key in inputs) {
            if (key === 'documents') {
                for(let i = 0; i < inputs.documents.length; i++ ){
                    formData.append('documents', inputs.documents[i]);
                }
            } else {
                formData.append(key, inputs[key]);
            }
        }
      
        try {
            const {data} = await file.insert(folderId, formData);
            console.log(data);
            setLoadingStatus(false);
            if( data.success ){
              setStatus(1);
              refetch();
              e.target.reset();
            }
            else{
              setStatus(-1); 
            } 
        } catch (err) { 
            setStatus(-1);
            setLoadingStatus(false);
        }
    }

    return (

        <div className="modal-container">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center vh-100 px-2">
                    <div className="col-lg-4 col-md-6 bg-white shadow border d-flex flex-column rounded-3">
                        <div className="row px-4 py-3 border-bottom" > 
                            <div className="d-flex justify-content-between align-items-center" > 
                                <span className="lead text-secondary"> Nouveau fichiers </span>
                                <button className="btn" onClick={ ()=>{ method ( false ) } } >
                                   <i className="bi bi-x-circle lead text-danger"></i> 
                                </button>
                            </div>
                        </div>
                        <form onSubmit={ handleForm } encType="multipart/form-data" className="row p-4 d-flex flex-column">
                            
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                              <div className="d-flex gap-2 mb-3">
                                <span className="d-flex flex-column gap-3 justify-content-center cursor text-secondary text-center border-dashed border-3 bg-light p-5 bg-light w-100">
                                    <label className="cursor" htmlFor="inputFile" >
                                        <i className="bi bi-arrow-up-circle me-2"></i> Uploader fichier
                                    </label>
                                    {
                                        size !== 0 && ( <span className="font-sm text-success"> { size } fichier(s)  </span> )
                                    }
                                </span>
                                <input type="file" name="documents" multiple accept="*/*" placeholder="Nom du dossier" id="inputFile" className={`hidden`} required onChange={ handleInputs } />
                              </div>
                            </div>
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                               <button type="submit" className="btn btn-green w-100" disabled={ ( isChecked === -1 || isChecked === 0 ) && true } > 
                                  Enregistrer <i className="bi bi-arrow-right"></i> 
                               </button> 
                            </div>
                        </form>
                        <div className="row justify-content-center d-flex px-4 py-3 border-top" > 
                            { 
                                isChecked === 1 ? ( 
                                    <label className="font-sm text-success text-center"> <i className="bi bi-check-circle-fill me-2"></i> Upload accepté </label> 
                                    ) : ( (isChecked === -1) ? (
                                        <label className="font-sm text-danger text-center"> <i className="bi bi-x-circle-fill me-2"></i> Vous ne pouvez pas uploader plus de 30 fichiers </label>  
                                        ) : ( <label className="text-secondary font-sm text-center"> <i className="bi bi-exclamation-circle me-2"></i> Uploader jusqu'à 30 fichiers </label> ) 
                                    )
                            }              
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}




export function LoaderModal( { close, isLoading, status } ){

    return(      
        <div className="loading-model shadow">
            <div className="d-flex flex-column w-100 bg-white rounded-3">
                <div className="d-flex justify-content-between align-items-center p-3">
                    <span className='color-green font-sm'> { ( isLoading ) ? "Chargement en cours..." : "Chargement terminé" }  </span>
                    { 
                       ( !isLoading ) && (
                           <button className="btn" onClick={ ()=>{ close( false ) } } >
                                <i className="bi bi-x-circle lead text-danger"></i> 
                            </button>
                       )
                    }
                </div> 
                <div className="d-flex justify-content-center align-items-center w-100 p-3 border-top">
                    { 
                       ( isLoading ) ? ( 
                            <img src='../../img/icons8-en-cours.gif' alt="" className="" height="50px" /> 
                        ) : (
                               ( status === 1) ? (
                                    <span className='color-green display-5'> <i className="bi bi-check-circle-fill"></i> </span>
                                    ) : (
                                        <span className='text-danger display-5'> <i className="bi bi-x-circle-fill"></i> </span>
                                    )
                                )
                    }
                </div>
            </div>
        </div> 
    )
}





export function RenameFileModal({ close, fileId, name, refetch })
{
    const file = FileApi();

    const handleInputs = ( event ) => {
        const { name, value } =  event.target;
        setInputs( { ...inputs, [name] : value   } );
    }

    const [inputs, setInputs] = useState({ name : name });
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleForm = async (e) => {
        e.preventDefault();
        setStatus(0);
        setIsLoading(true);
        try {
            const {data} = await file.updateOne( fileId, inputs);
            setIsLoading(false);
            if( data.success ) {
              setStatus(1);
              refetch();
            } 
            else {
              setStatus(-1); 
            }
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    }

    return (

        <div className="modal-container">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center vh-100 px-2">
                    <div className="col-lg-4 col-md-6 bg-white shadow border d-flex flex-column rounded-3">
                       <div className="row px-4 py-3 border-bottom" > 
                            <div className="d-flex justify-content-between align-items-center" > 
                                <span className="lead text-secondary"> Renommer un fichier </span>
                                <button className="btn" onClick={ ()=>{ close( false ) } } >
                                   <i className="bi bi-x-circle lead text-danger"></i> 
                                </button>
                            </div>
                        </div>
                        <form onSubmit={ handleForm } className="row p-4 d-flex flex-column">
                            
                            {
                              isLoading && (
                                <div className="d-flex justify-content-center align-items-center mb-3"> 
                                   <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                </div>
                              )
                            }
                            {
                              status === -1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-danger">
                                    Erreur de traitement. Réessayez.
                                  </div>
                                </div>
                              )
                            }
                            {
                              status === 1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-success">
                                    Fichier renommer avec succès.
                                  </div>
                                </div>
                              )
                            }
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                              <div className="d-flex gap-2 mb-3">
                                <input type="text" name="name" placeholder="Nom du fichier" value={inputs?.name} className={`w-100 input border py-3 px-3 text-secondary rounded-2`} required onChange={ handleInputs } />
                              </div>
                            </div>
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                               <button type="submit" className="btn btn-green w-100" > 
                                  Mettre à jour <i className="bi bi-arrow-right"></i> 
                               </button> 
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}








export function RemoveFileModal({ close, fileId, refetch })
{
    const file = FileApi();

    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleForm = async () => {
        setStatus(0);
        setIsLoading(true);
        try {
            const {data} = await file.deleteOne( fileId );
            setIsLoading(false);
            if( data.success ) {
              setStatus(1);
              refetch();
            } 
            else {
              setStatus(-1); 
            }
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    }

    return (

        <div className="modal-container">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center vh-100 px-2">
                    <div className="col-lg-4 col-md-6 bg-white shadow border d-flex flex-column rounded-3">
                       <div className="row px-4 py-3 border-bottom" > 
                            <div className="d-flex justify-content-between align-items-center" > 
                                <span className="lead text-secondary"> Suppression de fichier </span>
                                <button className="btn" onClick={ ()=>{ close( false ) } } >
                                   <i className="bi bi-x-circle lead text-danger"></i> 
                                </button>
                            </div>
                        </div>
                        <div className="row p-4 d-flex flex-column">
                            
                            {
                              isLoading && (
                                <div className="d-flex justify-content-center align-items-center mb-3"> 
                                   <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                </div>
                              )
                            }
                            {
                              status === -1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-danger">
                                    Erreur de traitement. Réessayez.
                                  </div>
                                </div>
                              )
                            }
                            {
                              status === 1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-success">
                                    Fichier supprimer avec succès.
                                  </div>
                                </div>
                              )
                            }
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                              <div className="d-flex mb-3">
                                  <p className="d-flex p-3 text-secondary border rounded bg-light">
                                    Etes vous sure de vouloir supprimer ce fichier ?
                                  </p>
                              </div>
                            </div>
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2">
                                <div className="d-flex gap-3 justify-content-between">
                                    <button className="btn btn-green px-3" onClick={ handleForm } > 
                                       Oui 
                                    </button> 
                                    <span className="btn btn-outline-danger px-3" onClick={ ()=>{ close( false ) } } > 
                                       Annuler
                                    </span> 
                                </div> 
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
